export default "__VITE_ASSET__CpudPnX7__"